<template>
    <div class="investor-profile-details">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-2">
                <b-col md="3" lg="6" cols="auto">
                    <router-link :to="'/funds_management/investors_profile'" class="text-primary">
                        <b-icon icon="chevron-left"></b-icon>
                        Back
                    </router-link>
                </b-col>
                <b-col md="9" lg="6" cols="auto" class="text-right">
                    <div class="header-assign-to-buttons">
                        <b-button-group class="mx-2">
                            <b-button size="sm" variant="outline-light">Referee</b-button>
                            <b-button class="text-dark" size="sm" variant="outline-light" disabled>—</b-button>
                        </b-button-group>
                        <el-button type="primary" class="py-2 px-5"><p>Add</p></el-button>
                        <el-dropdown trigger="click"  style="cursor: pointer" class="ml-4">
							<p class="el-dropdown-link mb-0 top-line">
								<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
							</p>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item> 
									<!-- Eye Icon -->
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512"><path fill="#13663E" d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>
									View Activity Log
								</el-dropdown-item>
								<el-dropdown-item>
									<span class="text-danger">
										<!-- Phone Icon -->
										<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512 512"><path fill="currentColor" d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64c0 247.4 200.6 448 448 448 18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368c-70.4-33.3-127.4-90.3-160.7-160.7l49.3-40.3c13.7-11.2 18.4-30 11.6-46.3l-40-96z"/></svg>
										View Call Log
									</span>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
                    </div>
                </b-col>
            </b-row>
        </base-header>

        <b-container fluid class="mt--6">
            <b-row>
                <b-col cols="12" lg="3">
                    <InvestorBiodata />
                    <DocumentsSts />
                    <Remarks />
                </b-col>
                <b-col cols="12" lg="9">
                    <el-tabs v-model="active_tab" @tab-click="handleChangeTab">
                        <el-tab-pane label="Overview" name="overview">
                            <b-row>
                                <b-col cols="12" lg="8">
                                    <ContributionSts />
                                    <b-row>
                                        <b-col cols="12" lg="6" v-for="(profile, index) in funder_profile" :key="index">
                                            <FundsCard  :funder_profile=profile />
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col cols="12" lg="4">
                                    <TransactionHistory />
                                </b-col>
                            </b-row>
                        </el-tab-pane>
                        <el-tab-pane label="Documents" name="documents">
                            <Documents />
                        </el-tab-pane>
                    </el-tabs>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { Button, Dropdown, DropdownMenu, DropdownItem, Tabs, TabPane } from 'element-ui'
import InvestorBiodata from '@/views/FundsMgmtInvestors/InvestorDetails/LeftComponents/InvestorBiodata'
import DocumentsSts from '@/views/FundsMgmtInvestors/InvestorDetails/LeftComponents/Documents'
import Remarks from '@/views/FundsMgmtInvestors/InvestorDetails/LeftComponents/Remarks'
import ContributionSts from '@/views/FundsMgmtInvestors/InvestorDetails/CenterComponents/ContributionSts'
import FundsCard from '@/views/FundsMgmtInvestors/InvestorDetails/CenterComponents/FundsCard'
import TransactionHistory from '@/views/FundsMgmtInvestors/InvestorDetails/RightComponents/TransactionHistory'
import Documents from '@/views/FundsMgmtInvestors/InvestorDetails/CenterComponents/Documents'

export default {
    components: {
        InvestorBiodata,
        DocumentsSts,
        Remarks,
        ContributionSts,
        FundsCard,
        TransactionHistory,
        Documents,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    data() {
        return {
            active_tab: 'overview',
            funder_profile: [
                {
                    name: 'JV Fund',
                    percent: '1.0-15%',
                    period: 'Half yearly (24 months)',
                    cont_amt: 6400,
                    cont_amt_percent: 80,
                    utd_profit: 9600,
                    utd_profit_percent: 7.5,
                    ref_no: 'ICSB_JVF-#003119',
                    or_no: 'IJVF/2023119',
                    profit_pa: 15,
                    start_date: '27 Jul 2023',
                    mature_date: '27 Jul 2025',
                    lot_per_10k: 6.4,
                    utd_interest_rel: 64000,
                    next_withdrawal: '27 Jul 2024'
                },
                {
                    name: 'Raya',
                    percent: '15%',
                    period: 'Monthly (36 months)',
                    cont_amt: 16000,
                    cont_amt_percent: 20,
                    utd_profit: 2400,
                    utd_profit_percent: 1.25,
                    ref_no: 'ICSB_JVF-#003005',
                    or_no: 'IJVF/2023005',
                    profit_pa: 15,
                    start_date: '28 Dec 2022',
                    mature_date: '28 Dec 2025',
                    lot_per_10k: 1.6,
                    utd_interest_rel: 16000,
                    next_withdrawal: '28 Jul 2024'
                },
            ]
        }
    },
    watch: {
        '$route.query.active': {
            handler(newValue, oldValue) {
                this.active_tab = newValue 
            },
            immediate: true
        }
    },
    methods: {
        handleChangeTab(obj, e){
            const query = { ...this.$route.query, active: obj.name }
            this.$router.push({path: this.$route.path, query})
        },
    }
}
</script>